import cx from 'classnames';
import { node, number, object, string } from 'prop-types';
import React from 'react';
import ColorMap from '../../mixins/ColorMap';
import style from './Svg.module.scss';

const Svg = ({ children, color, className, size, style: styleProp, width, height, ...rest }) => {
  return (
    <svg
      className={cx(style.svg, className)}
      style={{
        color: ColorMap[color] || color,
        width: `${width || size}px`,
        height: `${height || size}px`,
        ...styleProp,
      }}
      {...rest}
    >
      {children}
    </svg>
  );
};

Svg.propTypes = {
  children: node.isRequired,
  className: string,
  color: string,
  height: number,
  size: number,
  width: number,
  style: object,
};

Svg.defaultProps = {
  color: 'Mid Neutral 1',
  height: 16,
  width: 16,
  size: 16,
  className: undefined,
  style: {},
};

export default Svg;
